/* eslint-disable no-restricted-syntax */
import {Locale} from '@aboutyou/config';
import {getCurrencyConfigByLocale_UNSAFE} from './getCurrencyConfigByLocale';
import {getLongDateFormatForLocale_UNSAFE} from './getLongDateFormatForLocale';
import {getShortDateFormatForLocale_UNSAFE} from './getShortDateFormatForLocale';

/**
 * This is marked UNSAFE since this is never intended to be used on the browser bundle.
 * This is intended to be used only on SSR to generate static config
 */
export const getI18nConfig_UNSAFE = (locale: Locale) => {
  return {
    currencyConfig: getCurrencyConfigByLocale_UNSAFE(locale),
    dateFormat: {
      long: getLongDateFormatForLocale_UNSAFE(locale),
      short: getShortDateFormatForLocale_UNSAFE(locale),
    },
    serverDateNow: Date.now(),
  };
};
